import styled, { css } from 'styled-components';

import { color } from '../../../atoms/colors';
import { font } from '../../../atoms/typography';
import { spacing } from '../../../atoms/spacing';

const borderMap = {
  green: css`
    border-top: 5px solid var(--Green-500-P, #00b451);
  `,
  blue: css`
    border-top: 5px solid ${color.blue[700]};
  `,
};

const hoverMap = {
  green: css`
    background-color: ${color.green[50]};
  `,
  blue: css`
    background-color: ${color.darkBlue[25]};
  `,
};

export const Container = styled.div`
  position: sticky;
  top: 100px;
  width: 100%;
  max-height: calc(100vh - 116px);
  padding: ${spacing[16]};
  border-radius: 5px;
  background: ${color.common.white};
  box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.06),
    0px 1px 3px 0px rgba(16, 24, 40, 0.1);
  ${({ theme }) => borderMap[theme]}
`;

export const Header = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${spacing[8]};

  button {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    ${font('text', 'lg', '700')}
    color: ${color.darkBlue[900]};
    background-color: ${color.common.transparent};
    border: none;
    opacity: 1;
    transition: all 300ms ease-in-out;
  }
`;

export const List = styled.ul`
  width: 100%;
  max-height: 0px;
  padding: 0px;
  margin: 0px;
  list-style: none;
  opacity: 0;
  pointer-events: none;
  transition: all 300ms ease-in-out;

  overflow-y: scroll;

  &::-webkit-scrollbar {
    -webkit-appearance: none;
    width: 5px;
  }

  &::-webkit-scrollbar-thumb {
    border-radius: 4px;
    background-color: ${color.darkBlue[100]};
  }

  &.active {
    max-height: calc(100vh - 216px);
    opacity: 1;
    pointer-events: all;
    margin-top: 12px;
  }

  li {
    width: 100%;
    height: auto;
    padding: 8px;
    transition: all 300ms ease-in-out;

    a {
      display: block;
      width: 100%;
      height: auto;
      ${font('text', 'md', '400')}
      color: ${color.darkBlue[600]} !important;
    }

    &:hover {
      ${({ theme }) => hoverMap[theme]}
      border-radius: 4px;

      a {
        color: ${color.darkBlue[1000]} !important;
      }
    }
  }
`;
